import React, { useEffect, useState } from "react";
import { FlatList, Image, StyleSheet, Text, View } from "react-native";
import { connect } from "react-redux";
import { setCurrentOrder } from "../../actions/order";
import { fetchApi } from "../../api";
import { STYLES } from "../../assets/styles";
import { SCREEN_WIDTH } from "../../common";
import Container from "../../components/Container";
import Content from "../../components/Content";
import Header from "../../components/Header";
import moment from "moment";
import Review from "../../components/Review";

function Order({ setOrder, orderInfo = {}, navigation, route }) {
  const [isReady, setIsReady] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [amountInfo, setAmountInfo] = useState({
    total: 0,
    discount: 0,
    amount: 0,
  });

  const fetchOrderInfo = (callback) => {
    fetchApi({
      path: `/orders/${route.params.id}`,
    }).then((res) => {
      if (!res.error) {
        setOrder(res);
        let amountInfo = res.items.reduce(
          (acc, { count, price, mrp }) => {
            let a = price * count;
            let t = mrp * count;
            acc.total += t;
            acc.discount += t - a;
            acc.amount += a;
            return acc;
          },
          { total: 0, discount: 0, amount: 0 }
        );
        setAmountInfo(amountInfo);
        callback();
      } else {
        callback(res);
      }
    });
  };

  useEffect(() => {
    fetchOrderInfo(() => {
      setIsReady(true);
    });
  }, [route.params.id]);

  const onRefresh = () => {
    setRefreshing(true);
    fetchOrderInfo(() => {
      setRefreshing();
    });
  };

  const orderMessage = ({ type, payment, amount }) => {
    switch (type) {
      case "COD": {
        return `COD pay ${amount}`;
      }
      case "UPI": {
        return `UPI Payment Transaction ID ${payment.txnId}`;
      }
      default:
        return;
    }
  };

  const dateToString = (date) => {
    if (date) {
      return moment(date).format("h:mm:ss a, MMMM Do YYYY");
    }
    return "processing";
  };

  const Item = ({
    data: {
      _id,
      color,
      count,
      image_url,
      item_id,
      price,
      mrp,
      discount,
      size,
      title,
    },
    width = "100%",
  }) => (
    <View
      style={[
        styles.padding,
        {
          ...STYLES.shadow,
          width: width,
          marginRight: 5,
          justifyContent: "space-between",
          flexDirection: "row",
        },
      ]}
    >
      <Image
        source={{ uri: image_url }}
        resizeMode="contain"
        style={{
          height: 100,
          width: 100,
        }}
      />
      <View
        style={{
          marginHorizontal: 5,
          flex: 1,
          justifyContent: "space-between",
        }}
      >
        <Text style={{ fontSize: STYLES.fontSizes.medium, fontWeight: "bold" }}>
          {title}
        </Text>
        <View style={styles.flexWrap}>
          <Text style={{ fontSize: STYLES.fontSizes.small }}>
            Size : {size}
          </Text>
          <View
            style={{
              width: 15,
              height: 15,
              borderRadius: 7.5,
              marginHorizontal: 5,
              backgroundColor: color,
            }}
          />
        </View>
        <View style={styles.flexWrap}>
          <View style={{ flexDirection: "row", alignItems: "baseline" }}>
            {discount ? (
              <>
                <Text
                  style={{
                    fontSize: STYLES.fontSizes.mini,
                    fontWeight: "bold",
                    color: STYLES.colors.purpel,
                  }}
                >
                  {discount} %
                </Text>
                <Text
                  style={{
                    textDecorationLine: "line-through",
                    fontSize: STYLES.fontSizes.mini,
                    marginHorizontal: 5,
                    color: STYLES.colors.lightFontColor,
                  }}
                >
                  {mrp}
                </Text>
              </>
            ) : null}
            <Text
              style={{
                fontSize: STYLES.fontSizes.small,
                fontWeight: "bold",
              }}
            >
              {price}
            </Text>
            <Text>{" X " + count}</Text>
          </View>
          <Text
            style={{
              marginRight: 5,
              fontSize: STYLES.fontSizes.small,
            }}
          >
            Total : {price * count}
          </Text>
        </View>
      </View>
    </View>
  );

  const {
    _id,
    address = {},
    items = [],
    amount,
    review,
    created_at,
    order_type,
    shipping_date,
    delivery_date,
    is_shipped,
    payment = {},
    is_delivered,
    delivered_date,
  } = orderInfo;

  return (
    <Container>
      <Header
        title="My Order"
        rightIcons={[]}
        backButton
        navigation={navigation}
      />
      <Content
        refreshable={true}
        scrollEnabled={true}
        refreshing={refreshing}
        onRefresh={onRefresh}
        loading={!isReady}
        style={{ flex: 1 }}
      >
        <View style={{ marginVertical: 10 }}>
          {items.length > 1 ? (
            <FlatList
              horizontal
              data={items}
              showsHorizontalScrollIndicator={false}
              keyExtractor={(_, index) => index + "s"}
              contentContainerStyle={{ padding: 5 }}
              renderItem={({ item, index }) => (
                <Item
                  data={item}
                  width={SCREEN_WIDTH - 60}
                  key={index + "sd"}
                />
              )}
            />
          ) : (
            <Item data={items[0]} />
          )}
        </View>
        <View style={styles.padding}>
          <Text style={styles.boldFont}>Shipping Address</Text>
          <View style={{ paddingHorizontal: 10, paddingVertical: 5 }}>
            <View style={styles.flexWrap}>
              <Text style={{ fontWeight: "bold" }}>{address.name}</Text>
              <Text style={{ fontWeight: "bold" }}>{address.phone}</Text>
            </View>
            <Text style={{ fontSize: STYLES.fontSizes.small }}>
              {address.address}
            </Text>
            <Text style={{ fontSize: STYLES.fontSizes.small }}>
              {address.city}
            </Text>
            <Text style={{ fontSize: STYLES.fontSizes.small }}>
              {address.state}
            </Text>
            <Text style={{ fontSize: STYLES.fontSizes.small }}>
              {address.pincode}
            </Text>
          </View>
        </View>
        <View style={{ marginVertical: 5, padding: 10 }}>
          <Text style={styles.boldFont}>Order Tracking</Text>
          <View style={{ padding: 10 }}>
            <View
              style={[styles.progress, { borderColor: STYLES.colors.purpel }]}
            >
              <View
                style={[
                  styles.progressDot,
                  { backgroundColor: STYLES.colors.purpel },
                ]}
              />
              <Text style={styles.boldFont}>Order Placed</Text>
              <Text style={{ color: "#00000060" }}>
                Your order has been placed.
                {orderMessage({ type: order_type, payment, amount })}.
              </Text>
              <Text style={{ color: "#00000040" }}>
                {dateToString(created_at)}
              </Text>
            </View>
            <View
              style={[
                styles.progress,
                {
                  borderColor: is_shipped
                    ? STYLES.colors.purpel
                    : STYLES.colors.lightGrey,
                },
              ]}
            >
              <View
                style={[
                  styles.progressDot,
                  {
                    backgroundColor: is_shipped
                      ? STYLES.colors.purpel
                      : STYLES.colors.lightGrey,
                  },
                ]}
              />
              <Text style={styles.boldFont}>Shipped</Text>
              <Text
                style={{
                  color: is_shipped ? "#00000040" : "#000000",
                  fontSize: STYLES.fontSizes.small,
                }}
              >
                Expected by {dateToString(shipping_date)}
              </Text>
            </View>
            <View
              style={[
                styles.progress,
                {
                  borderColor: is_delivered
                    ? STYLES.colors.purpel
                    : STYLES.colors.lightGrey,
                },
              ]}
            >
              <View
                style={[
                  styles.progressDot,
                  {
                    backgroundColor: is_delivered
                      ? STYLES.colors.purpel
                      : STYLES.colors.lightGrey,
                  },
                ]}
              />
              <Text style={styles.boldFont}>Delivered</Text>
              <Text
                style={{
                  color: is_delivered ? "#00000040" : "#000000",
                  fontSize: STYLES.fontSizes.small,
                }}
              >
                Expected by {dateToString(delivery_date)}
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.padding}>
          <Text style={styles.boldFont}>Payment Details</Text>
          <View style={styles.txtContainer}>
            <Text>Total Amount</Text>
            <Text style={styles.value}>{amountInfo.total}</Text>
          </View>
          <View style={styles.txtContainer}>
            <Text>Discount</Text>
            <View style={{ flexDirection: "row", alignItems: "baseline" }}>
              <Text
                style={{
                  fontSize: STYLES.fontSizes.mini,
                  fontWeight: "bold",
                  color: STYLES.colors.carribeanGreen,
                }}
              >
                saved
              </Text>
              <Text
                style={{
                  fontSize: STYLES.fontSizes.mini,
                  fontWeight: "bold",
                  marginHorizontal: 5,
                  color: STYLES.colors.purpel,
                }}
              >
                {parseInt((amountInfo.discount / amountInfo.total) * 100)} %
              </Text>
              <Text style={styles.value}>- {amountInfo.discount}</Text>
            </View>
          </View>
          <View style={[styles.txtContainer]}>
            <Text style={styles.value}>Amount payable</Text>
            <Text style={styles.value}>{amountInfo.amount}</Text>
          </View>
        </View>
        {is_delivered ? (
          <View style={styles.shadowContainer}>
            <Text>Item Delivered on {dateToString(delivered_date)}</Text>
            <Review orderId={_id} prevReview={review} />
          </View>
        ) : null}
      </Content>
    </Container>
  );
}

const styles = StyleSheet.create({
  boldFont: { fontWeight: "bold", fontSize: STYLES.fontSizes.medium * 1.2 },
  flexWrap: {
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  padding: { paddingHorizontal: 15, paddingVertical: 10 },
  shadowContainer: {
    ...STYLES.shadow,
    marginVertical: 5,
    padding: 10,
  },
  progress: {
    borderLeftWidth: 5,
    paddingHorizontal: 15,
    paddingBottom: 10,
  },
  progressDot: {
    height: 20,
    width: 20,
    borderRadius: 10,
    left: -12.5,
    position: "absolute",
  },
  txtContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    margin: 5,
    borderBottomWidth: 1,
    borderColor: STYLES.colors.lightGrey,
  },
  value: {
    fontWeight: "bold",
  },
});

const mapStateToProps = (state) => ({
  orderInfo: state.order.currentOrder,
});

const mapDispatchToProps = (dispatch) => ({
  setOrder: (data) => dispatch(setCurrentOrder(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Order);
